module.exports = __webpack_public_path__ + "static/new-wave-of-future-scientists-f97f0c9c85abdc317bd9892d097c5738.jpg";